const maximumBytes = 16 * 1024 * 1024;

/** Request hides the original BodyInit. Bound both bytes and capture time before retaining it. */
export async function copyRequest(input: Request, init?: RequestInit): Promise<Request | null> {
  let result: Request | null;
  const effective = new Request(input.clone(), init);
  if (effective.method === 'GET' || effective.method === 'HEAD' || !effective.body) {
    result = effective;
  } else {
    const reader = effective.body.getReader();
    const chunks: Uint8Array[] = [];
    let bytes = 0;
    let stopped = false;
    const stop = (): void => {
      stopped = true;
      void reader.cancel().catch((): void => {});
    };
    const timer = setTimeout(stop, 15000);
    effective.signal.addEventListener('abort', stop, { once: true });
    try {
      if (effective.signal.aborted) {
        stop();
      }
      while (!stopped) {
        const { done, value } = await reader.read();
        if (done) {
          break;
        }
        bytes += value.byteLength;
        if (bytes > maximumBytes) {
          stop();
        } else {
          chunks.push(value);
        }
      }
      if (stopped) {
        result = null;
      } else {
        const body = new Uint8Array(bytes);
        let offset = 0;
        chunks.forEach((chunk) => {
          body.set(chunk, offset);
          offset += chunk.byteLength;
        });
        result = new Request(effective, { method: effective.method, body });
      }
    } catch {
      result = null;
    } finally {
      clearTimeout(timer);
      effective.signal.removeEventListener('abort', stop);
      chunks.length = 0;
      reader.releaseLock();
    }
  }

  return result;
}
